import React from "react";
import { Outlet } from "react-router-dom";

function Customers() {
  return (
    <div className="contact">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-7">
            <img
              class="img-fluid rounded mb-4 mb-lg-0"
              src="http://placehold.it/900x400"
              alt=""
            />
          </div>
          <div class="col-lg-5">
            <h1 class="font-weight-light">Pay With Nesctcoin</h1>
            <p>
              Exchange your Nestcoin Rewards for Backpasses, Coming soon.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Customers;
